import PropTypes from 'prop-types';

const ContactPerson = {};

ContactPerson.propTypes = {
    onPageEditing: PropTypes.bool,
    person: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        emailAddress: PropTypes.string,
        title: PropTypes.string,
        profilePicture: PropTypes.string,
        department: PropTypes.string,
        phone: PropTypes.string,
    }),
    contactLength: PropTypes.number,
    size: PropTypes.string,
    sendEmailLabel: PropTypes.string,
    hideEmailAddress: PropTypes.bool,
    small:PropTypes.bool
};

export default ContactPerson;



// WEBPACK FOOTER //
// ./src/components/Models/ContactPerson/ContactPerson.jsx